const state = {
  islogin: true,
  user: {}
}
const getters = {
  isLogin: (state) => {
    return state.islogin
  },
  user: (state) => {
    return state.user
  }
}
const mutations = {
  updateLogin (state, islogin, user) {
    state.islogin = islogin
    state.user = user
  }
}
export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js